module["exports"] = [
  "#{street_root}"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/tr/address/street_name.js
// module id = 1727
// module chunks = 0